import { render, staticRenderFns } from "./UserInvitationDialog.vue?vue&type=template&id=00cb246e&scoped=true&"
import script from "./UserInvitationDialog.vue?vue&type=script&lang=js&"
export * from "./UserInvitationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cb246e",
  null
  
)

export default component.exports